import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Las dietas restrictivas solo aumentan tu estrés biológico y bloquean la quema de grasa.', 'El cardio intenso agota tus glándulas suprarrenales y te deja más inflamada.', 'Los productos "light" del súper están cargados de azúcares ocultos que disparan tu insulina.', 'Contar calorías ignora por completo el caos hormonal de la perimenopausia y menopausia.'];
  return <section className="py-20 bg-white" data-id="element-142">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-143">
        {/* Opening Hook */}
        <FadeIn data-id="element-144">
          <div className="text-center mb-16" data-id="element-145">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-146">
              Si sentís que comés "lo mismo de siempre" pero tu ropa te queda
              cada vez más apretada,{' '}
              <span className="text-brand-orange" data-id="element-147">no estás sola.</span>
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed font-medium" data-id="element-148">
              No es falta de voluntad y mucho menos "la edad".
            </p>
            <p className="text-lg text-gray-600 mt-4 leading-relaxed" data-id="element-149">
              Tu cuerpo no está roto; simplemente cambió las reglas del juego. A
              partir de los 45 años, tu metabolismo ya no responde a las
              calorías, responde a las hormonas.
            </p>
          </div>
        </FadeIn>

        {/* The Problem */}
        <FadeIn delay={0.2} data-id="element-150">
          <div className="bg-brand-light rounded-2xl p-8 md:p-10 mb-16 border-l-4 border-brand-orange shadow-sm" data-id="element-151">
            <div className="flex items-start gap-4 mb-4" data-id="element-152">
              <AlertTriangle className="w-8 h-8 text-brand-orange flex-shrink-0 mt-1" data-id="element-153" />
              <h3 className="font-serif text-2xl font-bold text-brand-charcoal" data-id="element-154">
                Después de los 45, el déficit calórico tradicional es tu peor
                enemigo.
              </h3>
            </div>
            <div className="space-y-4 text-gray-700 ml-0 md:ml-12" data-id="element-155">
              <p className="leading-relaxed" data-id="element-156">
                Cuando intentás comer menos y hacer más cardio, tu cortisol se
                dispara, enviándole a tu cuerpo una señal de alarma clara:{' '}
                <strong data-id="element-157">"Guardá toda la grasa posible en el abdomen"</strong>.
              </p>
              <p className="leading-relaxed" data-id="element-158">
                Por eso te despertás cansada, sentís esa hinchazón abdominal que
                no cede con nada y tenés antojos incontrolables de algo dulce a
                las 4 de la tarde. Estas intentando manejar un motor moderno con
                un manual de los años 80.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Why what you tried didn't work */}
        <FadeIn delay={0.3} data-id="element-159">
          <div className="mb-10" data-id="element-160">
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-center text-brand-charcoal mb-10" data-id="element-161">
              Por qué lo que intentaste hasta ahora{' '}
              <span className="text-red-600 underline decoration-red-200 decoration-4 underline-offset-4" data-id="element-162">
                no funcionó
              </span>
            </h3>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-163">
              {failedAttempts.map((item, index) => <FadeIn key={index} delay={0.4 + index * 0.1} direction="up" data-id="element-164">
                  <div className="flex items-start gap-4 p-6 rounded-xl bg-gray-50 border border-gray-100 h-full hover:shadow-md transition-shadow" data-id="element-165">
                    <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-166" />
                    <p className="text-gray-700 font-medium leading-relaxed" data-id="element-167">
                      {item}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}